import React, { useEffect, useContext } from "react";

import {
  Grid,
  Card,
  TextField,
  FormControl,
  FormHelperText,
  IconButton,
  Divider,
  InputLabel,
  OutlinedInput,
  InputAdornment,
  CircularProgress,
  Tooltip,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Autocomplete, createFilterOptions } from "@material-ui/lab";
import AddIcon from "@material-ui/icons/Add";
import InfoIcon from "@material-ui/icons/Info";
import DeleteIcon from "@material-ui/icons/Delete";
import _, { debounce } from "lodash";
import { isValid } from "date-fns";
import { useIntl, FormattedMessage } from "react-intl";
import { formatMessage } from "utils/MyFunctions";
import userContext from "contexts/userContext";
import axios from "axios";
export default function LivePreviewExample(props) {
  const { role, setRole, locale } = useContext(userContext);
  const intl = useIntl();
  const requestOptions = {
    method: "GET",
    redirect: "follow",
    headers: {
      Accept: "application/ld+json",
      Authorization: "Bearer " + localStorage.getItem("TOKEN_BEARER"),
      // 'Content-Type': 'application/x-www-form-urlencoded',
    },
  };
  const [existingNIU, setExistingNIU] = React.useState(false);
  const MASTER_API_URL = process.env.REACT_APP_MASTER_API_URL;
  const MONOLITH_API_URL = process.env.REACT_APP_MONOLITH_API_URL;

  const [values, setValues] = React.useState([
    {
      uuid: "",
      niu: "",
      nom: "",
      tel: "",
      email: "",
      adresse: "",
      ville: "",
    },
  ]);
  const [blocked, setBlocked] = React.useState(false);
  const [niucheck, setNIUCheck] = React.useState([false]);

  const [errors, setErrors] = React.useState([
    {
      niu: "",
      nom: "",
      tel: "",
      email: "",
      adresse: "",
      ville: "",
    },
  ]);
  const [helpers, setHelpers] = React.useState([
    {
      niu: "",
      nom: "",
      tel: "",
      email: "",
      adresse: "",
      ville: "",
    },
  ]);

  // function sleep(delay = 0) {
  //   return new Promise((resolve) => {
  //     setTimeout(resolve, delay);
  //   });
  // }

  const [villes, setVilles] = React.useState([]);
  const [villesR, setVillesR] = React.useState([]);

  const [fixedValue, setFixedValue] = React.useState({});

  const [openC, setOpenC] = React.useState([false]);
  const [openT, setOpenT] = React.useState([false]);
  const [chargeurs, setChargeurs] = React.useState([]);
  const [fetching, setFetching] = React.useState(false);
  const loadingC = openC.includes(true) && fetching;
  const loadingT = openT.includes(true) && fetching;
  const [createMode, setCreateMode] = React.useState([false]);
  const [blockage, setBlockage] = React.useState(false);

  const checkBlockage = () => {
    props.setLoading(true);
    console.log("CHECKING BLOCKAGE, CM : ", createMode);

    console.log("CHECKING BLOCKAGE...");
    console.log("values : ", values);

    if (values[0].nom === "") {
      let _errors = [...errors];
      let _helpers = [...helpers];
      _errors[0].nom = false;
      _helpers[0].nom = "";

      setErrors(_errors);
      setHelpers(_helpers);
      props.setLoading(false);
    } else {
      let config = {
        method: "POST",
        maxBodyLength: Infinity,
        url: MONOLITH_API_URL + "/bescs/can-create",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("TOKEN_BEARER"),
        },
        data: { exporter_uuid: values[0].uuid },
      };
      axios
        .request(config)
        .then((response) => {
          let _bescs = response.data.bescs;
          let _filter = _bescs.filter(
            (b) => b.number.toUpperCase() === props.number.toUpperCase(),
          );
          console.log("props: ", props);
          console.log("filter : ", _filter);
          console.log("resp : ", response.data);
          console.log();
          if (!response.data.decision && _filter.length == 0) {
            let _errors = [...errors];
            let _helpers = [...helpers];
            const bescList = _bescs
              .map(
                (b) =>
                  `• ${b.number} (initié le ${new Date(
                    b.initiatedAt.date,
                  ).toLocaleDateString("fr-FR")})`,
              )
              .join("\n");
            const _role =
              props.sens.toLowerCase() === "export"
                ? "cet expéditeur"
                : "ce destinataire";
            const helperMessage =
              "La création de BESCs est actuellement désactivée pour " +
              _role +
              ".\n\n" +
              _role +
              " est bloqué en raison de BESCs initiés mais non finalisés.\n" +
              "Veuillez finaliser les BESCs suivants pour le débloquer :\n \n \n " +
              bescList;
            if (response.data.msg) {
              helperMessage = response.data.msg;
            }
            _errors[0].nom = true;
            _helpers[0].nom = helperMessage;

            setErrors(_errors);
            setHelpers(_helpers);
            setBlockage(true);
          } else {
            let _errors = [...errors];
            let _helpers = [...helpers];
            _errors[0].nom = false;
            _helpers[0].nom = "";

            setErrors(_errors);
            setHelpers(_helpers);
            setBlockage(false);
          }
          props.setLoading(false);
        })
        .catch((error) => {
          props.setLoading(false);
          console.log("error!! error below :");
          console.log(error);
          return error;
        });
    }
  };
  useEffect(() => {
    console.log("role changed(CHARGEUR), role : ", role);
    if (
      role &&
      role.user &&
      role.user.company &&
      role.user.company.account_local === "0" &&
      ["Chargeur Principal", "Sous Compte Chargeur"].includes(
        role.user.roles[0].name,
      ) &&
      !role.user.company.special_authorization &&
      !role.user.company.forwarding_agent &&
      !role.user.company.consignataire
    ) {
      //CHECK IF EXISTS

      (async () => {
        try {
          const response = await fetch(
            props.api +
              "/api/shipper_aliases?taxpayer_number=" +
              role.user.company.taxpayer_id,
            requestOptions,
          );

          //await sleep(1e3); // For demo purposes.
          let _shippers = await response.json();
          _shippers = _shippers["hydra:member"];

          //EXISTS
          if (_shippers.length > 0) {
            console.log("EXISTS!!!!!!!!");
            setFixedValue({
              uuid: _shippers[0].uuid,
              nom: _shippers[0].name,
              niu: _shippers[0].taxpayerNumber,
              tel: _shippers[0].phone,
              email: _shippers[0].email,
              adresse: _shippers[0].address,
              ville: "",
            });
          } else {
            //DOESN'T EXIST
            console.log("ELSE");
            let _cm = [...createMode];
            _cm[values.length - 1] = true;
            console.log("setting createmode as : ", _cm);
            setCreateMode(_cm);
            let _values = [...values];
            _values[0] = {
              nom: role.user.company.raison_sociale,
              niu: role.user.company.taxpayer_id,
              tel: role.user.company.telephone,
              email: role.user.company.email,
              adresse: role.user.company.address,
              ville: "",
            };
            console.log("setting valuess to : ", _values);
            setValues(_values);
            setFixedValue(_values[0]);
          }
        } catch {
          (e) => {
            console.log("an error occured, details : ", e);
          };
        }
      })();
    }
  }, [role]);

  useEffect(() => {
    console.log("createMode changed, createMode : ", createMode);
  }, [createMode]);

  const debounceCheckNIU = _.debounce(async (niu, index) => {
    try {
      const response = await fetch(
        props.api + "/api/shipper_aliases?taxpayer_number=" + niu,
        requestOptions,
      );

      //await sleep(1e3); // For demo purposes.
      let _shippers = await response.json();
      _shippers = _shippers["hydra:member"];
      if (_shippers.length > 0) {
        let _errors = [...errors];
        let _helpers = [...helpers];
        _errors[index].niu = true;
        _helpers[index].niu = formatMessage(
          intl,
          "create_besc_maritime_import_accordion_shippers_card_recipient_helper_existing_taxpayer_number",
        );

        setErrors(_errors);
        setHelpers(_helpers);
        setExistingNIU(true);
      } else {
        setExistingNIU(false);
      }
      let _niucheck = [...niucheck];
      _niucheck[index] = false;
      setNIUCheck(_niucheck);
    } catch {
      (e) => {
        console.log("an error occured, details : ", e);
      };
    }
  }, 600);

  const debounceLoadChargeur = _.debounce(async (search) => {
    try {
      const response = await fetch(
        props.api + "/api/shipper_aliases?name=" + search,
        requestOptions,
      );

      //await sleep(1e3); // For demo purposes.
      let _shippers = await response.json();
      _shippers = _shippers["hydra:member"];

      let options = [];
      for (let s of _shippers) {
        options.push({
          uuid: s.uuid,
          nom: s.name,
          niu: s.taxpayer_number,
          tel: s.phone,
          email: s.email,
          adresse: s.address,
          ville: "",
        });
      }
      setChargeurs(options);
    } catch {
      (e) => {
        console.log("an error occured, details : ", e);
      };
    }
  }, 600);

  //DEBOUNCE LOAD TOWNS

  const debounceLoadVilles = _.debounce(async (search) => {
    try {
      const response = await fetch(
        props.api + "/api/towns?name=" + search,
        requestOptions,
      );

      //await sleep(1e3); // For demo purposes.
      let _shippers = await response.json();
      _shippers = _shippers["hydra:member"];

      let options = [];
      //
      for (let res of _shippers) {
        options.push({
          id: res["@id"],
          ville: res.name,
          pays: res.countryName,
          countryId: res.country,
        });
      }

      setVilles(options);
    } catch {
      (e) => {
        console.log("an error occured, details : ", e);
      };
    }
  }, 600);

  const validateValues = () => {
    let _errors = [...errors];
    let _helpers = [...helpers];
    // if (values.nom === '') {
    //   errors.nom = true;
    //   helpers.nom = 'Ce champ ne peut être vide';
    // }
    values.forEach((value, index) => {
      // _errors.push({
      //   niu: "",
      //   nom: "",
      //   tel: "",
      //   email: "",
      //   adresse: "",
      //   ville: "",
      // });
      // _helpers.push({
      //   niu: "",
      //   nom: "",
      //   tel: "",
      //   email: "",
      //   adresse: "",
      //   ville: "",
      // });

      if (createMode[0] && value.tel !== "") {
        console.log("FIRST IF");
        let regex1 = new RegExp(/^6(2|5|6|7|8|9)[0-9]{7}$/);
        let regex2 = new RegExp(/^2(22|33|42|43)[0-9]{6}$/);
        if (value.tel && !regex1.test(value.tel) && !regex2.test(value.tel)) {
          console.log("PHONE TEST FAILED");
          _errors[index]["tel"] = true;
          _helpers[index]["tel"] = formatMessage(
            intl,
            "create_besc_maritime_import_accordion_shippers_card_recipient_helper_invalid_phone",
          );
        } else {
          console.log("PHONE TEST PASSED");
          _errors[index]["tel"] = false;
          _helpers[index]["tel"] = "";
        }
      }
      if (createMode[0] && value.niu !== "") {
        console.log("SECOND IF");
        let regex = new RegExp(/^[A-Z]([A-Z]|[0-9]){13}$/);

        if (value.niu && !regex.test(value.niu.toUpperCase())) {
          console.log("NIU TEST FAILED");
          _errors[index]["niu"] = true;
          _helpers[index]["niu"] = formatMessage(
            intl,
            "create_besc_maritime_import_accordion_shippers_card_recipient_helper_invalid_taxpayer_number",
          );
        } else {
          console.log("NIU TEST PASSED");
          if (!existingNIU) {
            _errors[index]["niu"] = false;
            _helpers[index]["niu"] = "";
          }
        }
      }
      if (createMode[0] && value.email !== "") {
        console.log("THIRD IF");
        let regex = new RegExp(
          /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
        );
        if (value.email && !regex.test(value.email)) {
          console.log("EMAIL TEST FAILED");
          _errors[index]["email"] = true;
          _helpers[index]["email"] = formatMessage(
            intl,
            "create_besc_maritime_import_accordion_shippers_card_recipient_helper_invalid_email",
          );
        } else {
          console.log("EMAIL TEST PASSED");
          _errors[index]["email"] = false;
          _helpers[index]["email"] = "";
        }
      }
    });

    setErrors(_errors);
    setHelpers(_helpers);
  };

  useEffect(() => {
    console.log("props data changed");
    console.log(props.data);
    if (props.data.length > 0) {
      setValues(props.data);
    }
  }, [props.data]);

  useEffect(() => {
    console.log("propss cMode changed");
    console.log(props.cMode);
    if (props.cMode) {
      setCreateMode([props.cMode]);
    }
  }, [props.cMode]);

  useEffect(() => {
    console.log(
      "props partnersData changed, props partnersData : ",
      props.partnersData,
    );

    if (props.partnersData.length > 0) {
      console.log("props partners DATA : ", props.partnersData);
      let lastData = props.partnersData[props.partnersData.length - 1];

      if (values[0].niu) {
        if (values[0].niu == lastData.chargeur.niu) {
          console.log("Correct, it's the same shipper");
        } else {
          console.log("different shipper, signal error ");
        }
      } else {
        console.log("shippers was empty... setting shipper");

        console.log("adding shipper");
        props.setLoading(true);
        fetch(
          MASTER_API_URL +
            "/api/shipper_aliases?taxpayer_number=" +
            lastData.chargeur.niu,
          requestOptions,
        )
          .then((response) => response.json())
          .then((result) => result["hydra:member"])
          .then((result) => {
            if (result.length > 0) {
              let _values = [...values];
              _values[0] = {
                uuid: result[0].uuid,
                nom: result[0].name,
                niu: result[0].taxpayer_number,
                tel: result[0].phone,
                email: result[0].email,
                adresse: result[0].address,
                ville: "",
              };
              setValues(_values);
              props.setLoading(false);
            } else {
              let _values = [...values];
              _values[0] = {
                niu: lastData.chargeur.niu,
                nom: lastData.chargeur.name,
                tel: lastData.chargeur.phone,
                email: lastData.chargeur.email,
                adresse: lastData.chargeur.address,
                ville: "",
              };
              if (_values[0].tel.search("237") == 0) {
                console.log("tel having 237");
                _values[0].tel = _values[0].tel.replace("237", "");
              } else {
                console.log("tel not having 237");
              }

              let _cm = [...createMode];
              _cm[_values.length - 1] = true;
              setCreateMode(_cm);
              setValues(_values);
              props.setLoading(false);
            }
          });
      }
    } else {
      let _values = [...values];
      _values[0] = {
        uuid: "",
        niu: "",
        nom: "",
        tel: "",
        email: "",
        adresse: "",
        ville: "",
      };
      setValues(_values);
      props.sendChargeurs(_values);
      console.log("ALL TRANSACTIONS DELETED");
    }
  }, [props.partnersData]);

  useEffect(() => {
    console.log("values changed, values : ", values);
  }, [values]);

  useEffect(() => {
    console.log("props : ", props);
    props.sendChargeurs(values);
    // console.log("sending createmode initial : ", createMode);
    // props.sendCreateMode(createMode[0]);

    let _villesR = [];

    //LOAD THE TOWNS FROM CAMEROON
    fetch(
      props.api + "/api/towns?country.code=CM&itemsPerPage=40",
      requestOptions,
    )
      .then((response) => response.json())
      .then((result) => result["hydra:member"])
      .then((result) => {
        for (let res of result) {
          _villesR.push({
            id: res["@id"],
            ville: res.name,
            pays: res.countryName,
            countryId: res.country,
          });
        }

        setVillesR(_villesR);
      });
  }, []);

  useEffect(() => {
    let validity =
      (role && role.user && role.user.company.consignataire) ||
      (values.length > 0 && values[0].nom && values[0].nom.length > 0);
    console.log("errors : ", errors);
    console.log("validity before (ERRORS USEFFECT) : ", validity);
    console.log("value  : ", values);

    let excluded_fields =
      role && role.user && role.user.company.consignataire
        ? ["adresse", "niu"]
        : ["adresse"];
    let req_fields = createMode[0]
      ? Object.keys(values[0]).filter((v) => !excluded_fields.includes(v))
      : Object.keys(values[0]).filter((v) => ["nom"].includes(v));
    req_fields.map((rf) => {
      // console.log("TEST OF A REQUIRED FIELD NAMED ", rf);
      // console.log("val : ", values[0][rf]);
      let _eval = values[0][rf];
      if (_eval) {
        // console.log("ok");
      } else {
        // console.log("nok");
      }
      validity = validity && !!_eval;
      // console.log("validity : ", validity);
    });

    console.log("validity after all checks (ERRORS USEFFECT)  : ", validity);
    let isvalid = true;
    console.log("ERRORS is : ", errors);

    if (errors.length > 0) {
      for (const [index, err] of errors.entries()) {
        console.log("Object values ERRORS is : ", Object.values(err));
        if (Object.values(err).includes(true)) {
          isvalid = false;

          break;
        }
      }
    }
    // console.log("isValid : ", isvalid);
    validity = validity && isvalid && !existingNIU;
    // console.log("changing validity(chargeurs) to : ", validity);
    if (!niucheck[0]) {
      props.setValidity(validity);
    }

    if (validity) {
      props.sendChargeurs(values);
    }
  }, [errors, niucheck]);

  useEffect(() => {
    setFetching(false);
  }, [chargeurs]);

  useEffect(() => {
    setFetching(false);
  }, [villes]);

  useEffect(() => {
    if (!openC.includes(true)) {
      setChargeurs([]);
    }
  }, [openC]);

  useEffect(() => {
    if (createMode[0]) {
      let _errors = [...errors];
      let _helpers = [...helpers];
      _errors[0].nom = false;
      _helpers[0].nom = "";

      setErrors(_errors);
      setHelpers(_helpers);
    }
    if (
      role &&
      role.user &&
      role.user.company &&
      role.user.company.account_local === "0" &&
      ["Chargeur Principal", "Sous Compte Chargeur"].includes(
        role.user.roles[0].name,
      ) &&
      !role.user.company.special_authorization &&
      !role.user.company.forwarding_agent &&
      !role.user.company.consignataire &&
      fixedValue.niu
    ) {
    } else {
      //CHECK FOR ERRORS ON FORM
      validateValues();
      let validity = values[0].nom.length > 0;

      console.log("validity before : ", validity);
      let excluded_fields =
        role && role.user && role.user.company.consignataire
          ? ["adresse", "niu"]
          : ["adresse"];
      let req_fields = createMode[0]
        ? Object.keys(values[0]).filter((v) => !excluded_fields.includes(v))
        : Object.keys(values[0]).filter((v) => ["nom"].includes(v));
      req_fields.map((rf) => {
        // console.log("TEST OF A REQUIRED FIELD NAMED ", rf);
        // console.log("val : ", values[0][rf]);
        let _eval = values[0][rf];
        if (_eval) {
          // console.log("ok");
        } else {
          // console.log("nok");
        }
        validity = validity && !!_eval;
        console.log("validity : ", validity);
      });

      console.log("validity after all checks : ", validity);

      let isvalid = true;
      if (errors.length > 0) {
        for (const [index, err] of errors.entries()) {
          if (Object.values(err).includes(true)) {
            isvalid = false;

            break;
          }
        }
      }
      console.log("isValid : ", isvalid);

      validity = validity && isvalid && !existingNIU;
      console.log("validity (final) : ", validity);
      if (!niucheck[0]) {
        props.setValidity(validity);
      }

      if (
        !createMode[0] &&
        props.sens &&
        ((props.bescStatus && props.bescStatus === "created") ||
          props.mode === "create")
        // props.sens.toLowerCase() === "export"
      ) {
        props.setLoading(true);
        checkBlockage();
      }

      if (validity) {
        console.log("validity true, sending chargeurs and createMode");
        props.sendChargeurs(values);
        console.log("sending createmode chargeurs changed : ", createMode);
        props.sendCreateMode(createMode[0]);
      }
    }
    console.log("props (checkstatus): ", props);
  }, [values, niucheck]);

  useEffect(() => {
    //required fields
    console.log("fixedValue changed, fixedValue : ", fixedValue);
    if (
      role &&
      role.user &&
      role.user.company &&
      role.user.company.account_local === "0" &&
      ["Chargeur Principal", "Sous Compte Chargeur"].includes(
        role.user.roles[0].name,
      ) &&
      !role.user.company.special_authorization &&
      !role.user.company.forwarding_agent &&
      !role.user.company.consignataire &&
      fixedValue.niu
    ) {
      console.log("FIXED");
      ////////////////////////////

      let validity = fixedValue.niu.length > 0;

      console.log("validity before : ", validity);

      let req_fields = createMode[0] ? ["ville"] : [];
      req_fields.map((rf) => {
        console.log("TEST OF A REQUIRED FIELD NAMED ", rf);
        console.log("val : ", fixedValue[rf]);
        let _eval = fixedValue[rf];
        if (_eval) {
          console.log("ok");
        } else {
          console.log("nok");
        }
        validity = validity && !!_eval;
        console.log("validity : ", validity);
      });

      console.log("validity after all checks : ", validity);

      let isvalid = true;
      if (errors.length > 0) {
        for (const [index, err] of errors.entries()) {
          if (Object.values(err).includes(true)) {
            isvalid = false;

            break;
          }
        }
      }
      console.log("isValid : ", isvalid);

      validity = validity && isvalid;
      console.log("validity (final) : ", validity);
      props.setValidity(validity);
      if (validity) {
        console.log("validity true, sending chargeurs and createMode");
        props.sendChargeurs([fixedValue]);
        console.log("sending createmode chargeurs changed : ", createMode);
        props.sendCreateMode(createMode[0]);
      }

      ////////////////////////////
    } else {
      console.log("NOT FIXED!!!");
    }
  }, [fixedValue]);

  useEffect(() => {}, []);

  const filter = createFilterOptions();

  const handleChange = async (index, event) => {
    event.persist(event);
    if (
      role &&
      role.user &&
      role.user.company &&
      role.user.company.account_local === "0" &&
      ["Chargeur Principal", "Sous Compte Chargeur"].includes(
        role.user.roles[0].name,
      ) &&
      !role.user.company.special_authorization &&
      !role.user.company.consignataire &&
      !role.user.company.forwarding_agent
    ) {
      setFixedValue({ ...fixedValue, [event.target.name]: event.target.value });
    } else {
      let _values = [...values];
      _values[index][event.target.name] = event.target.value;
      setValues(_values);
    }

    if (event.target.name == "niu") {
      if (createMode[index] && event.target.value.length == 14) {
        let _niucheck = [...niucheck];
        _niucheck[index] = true;
        setNIUCheck(_niucheck);
        debounceCheckNIU(event.target.value, index);
      }
    }
  };

  const handleAutoCompleteChange = (index, event, newValue) => {
    console.log("newVALUE : ", newValue);
    if (newValue && typeof newValue["nom"] === "string") {
      let _values = [...values];
      _values[index] = newValue;

      setValues(_values);
      let _cm = [...createMode];
      _cm[index] = false;
      setCreateMode(_cm);
    } else if (newValue && newValue.inputValue) {
      let _values = [...values];

      _values[index] = {
        niu: "",
        nom: newValue.inputValue,
        tel: "",
        email: "",
        adresse: "",
        ville: "",
      };

      setValues(_values);
      let _cm = [...createMode];
      _cm[index] = true;
      setCreateMode(_cm);
    } else {
      let _values = [...values];
      _values[index] = {
        niu: "",
        nom: "",
        tel: "",
        email: "",
        adresse: "",
        ville: "",
      };

      setValues(_values);
      let _cm = [...createMode];
      _cm[index] = false;
      setCreateMode(_cm);
      props.sendChargeurs(_values);
    }
  };

  const handleAutoCompleteChangeV = (index, event, newValue) => {
    if (
      role &&
      role.user &&
      role.user.company &&
      role.user.company.account_local === "0" &&
      ["Chargeur Principal", "Sous Compte Chargeur"].includes(
        role.user.roles[0].name,
      ) &&
      !role.user.company.special_authorization &&
      !role.user.company.consignataire &&
      !role.user.company.forwarding_agent
    ) {
      setFixedValue({ ...fixedValue, [event.target.name]: event.target.value });

      if (newValue && typeof newValue["ville"] === "string") {
        setFixedValue({ ...fixedValue, ["ville"]: newValue });
      } else {
        setFixedValue({ ...fixedValue, ["ville"]: "" });
      }
    } else {
      if (newValue && typeof newValue["ville"] === "string") {
        let _values = [...values];
        _values[index].ville = newValue;

        setValues(_values);
      } else {
        let _values = [...values];
        _values[index].ville = "";
        setValues(_values);
      }
    }
  };

  const removeChargeur = (_index) => {
    let _values = [...values];

    _values = _values.filter((value, index) => index !== _index);

    setValues(_values);
  };

  const useStyles = makeStyles((theme) => ({
    root: {
      display: "flex",
      flexWrap: "wrap",
    },
    tabPanelRoot: {
      padding: 0,
    },
    panel: {
      width: "100%",
    },
    margin: {
      margin: theme.spacing(1),
    },
    withoutLabel: {
      marginTop: theme.spacing(3),
    },
    textField: {
      width: 300,
      fontSize: 24,
    },
    OutlinedInput: {
      fontSize: "12px",
    },
    overrides: {
      MuiFormLabel: {
        asterisk: {
          color: "red",
        },
      },
    },
  }));

  const classes = useStyles();
  return (
    <Card className="p-4 mb-4">
      {/* -------------------------------------- Chargeurs ----------------------------------- */}
      <div className="font-size-lg font-weight-bold">
        {props.headTitle}
        {/* <IconButton aria-label="delete" onClick={addChargeur}>
          <AddIcon />
        </IconButton> */}
      </div>
      <form id="chargeur-form">
        {values.map((value, index) => {
          return (
            <div>
              <Divider className="my-4" />
              <Grid container direction="row" spacing={2}>
                <Grid item xs={8} sm={6} md={3}>
                  <FormControl
                    fullWidth
                    className={classes.margin}
                    variant="outlined"
                  >
                    <Autocomplete
                      open={openC[index]}
                      onOpen={(options) => {
                        let o = [...openC];

                        o[index] = true;
                        setOpenC(o);
                      }}
                      onClose={() => {
                        let o = [...openC];
                        o[index] = false;
                        setOpenC(o);
                        setChargeurs([]);
                      }}
                      loading={loadingC}
                      loadingText={formatMessage(
                        intl,
                        "create_besc_maritime_import_accordion_shippers_card_recipient_label_searching",
                      )}
                      value={
                        role &&
                        role.user &&
                        role.user.company &&
                        role.user.company.account_local === "0" &&
                        ["Chargeur Principal", "Sous Compte Chargeur"].includes(
                          role.user.roles[0].name,
                        ) &&
                        !role.user.company.special_authorization &&
                        !role.user.company.forwarding_agent &&
                        !role.user.company.consignataire &&
                        fixedValue.nom
                          ? fixedValue.nom
                          : value.nom
                      }
                      size="small"
                      onChange={(event, newValue) =>
                        handleAutoCompleteChange(index, event, newValue)
                      }
                      filterOptions={(options, params) => {
                        if (!loadingC) {
                          const filtered = filter(options, params);
                          // Suggest the creation of a new value
                          if (
                            params.inputValue !== "" &&
                            !loadingC &&
                            (filtered.length != 1 ||
                              params.inputValue.toLowerCase() !==
                                filtered[0].nom.toLowerCase())
                          ) {
                            filtered.push({
                              inputValue: params.inputValue,
                              text: "Créer " + params.inputValue,
                            });
                          }

                          return filtered;
                        } else {
                          return [];
                        }
                      }}
                      id="free-solo-with-text-demo"
                      options={chargeurs}
                      getOptionLabel={(option) => {
                        // Value selected with enter, right from the input
                        if (typeof option === "string") {
                          return option;
                        }
                        // Add "xxx" option created dynamically
                        if (option.inputValue) {
                          return option.text;
                        }
                        // Regular option

                        return option.nom;
                      }}
                      renderInput={(params) =>
                        props.partnersData.length <= 0 &&
                        !(
                          role &&
                          role.user &&
                          role.user.company &&
                          role.user.company.account_local === "0" &&
                          [
                            "Chargeur Principal",
                            "Sous Compte Chargeur",
                          ].includes(role.user.roles[0].name) &&
                          !role.user.company.special_authorization &&
                          !role.user.company.consignataire &&
                          !role.user.company.forwarding_agent
                        ) ? (
                          <TextField
                            fullWidth
                            {...params}
                            label={formatMessage(
                              intl,
                              "create_besc_maritime_import_accordion_shippers_card_recipient_label_name",
                            )}
                            variant="outlined"
                            required
                            InputLabelProps={{
                              shrink: true,
                            }}
                            onChange={(event) => {
                              event.persist(event);
                              if (event.target.value.length > 2) {
                                if (!fetching) {
                                  setFetching(true);
                                }
                                debounceLoadChargeur(event.target.value);
                              }
                            }}
                          />
                        ) : (
                          <TextField
                            fullWidth
                            {...params}
                            label={formatMessage(
                              intl,
                              "create_besc_maritime_import_accordion_shippers_card_recipient_label_name",
                            )}
                            variant="outlined"
                            InputProps={{
                              readOnly:
                                props.partnersData.length > 0 ||
                                (role &&
                                  role.user &&
                                  role.user.company &&
                                  role.user.company.account_local === "0" &&
                                  [
                                    "Chargeur Principal",
                                    "Sous Compte Chargeur",
                                  ].includes(role.user.roles[0].name) &&
                                  !role.user.company.special_authorization &&
                                  !role.user.company.consignataire &&
                                  !role.user.company.forwarding_agent),
                            }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            required
                            onChange={(event) => {
                              event.persist(event);
                              if (event.target.value.length > 2) {
                                if (!fetching) {
                                  setFetching(true);
                                }
                                debounceLoadChargeur(event.target.value);
                              }
                            }}
                            error={!errors[index] ? false : errors[index].nom}
                          />
                        )
                      }
                    ></Autocomplete>

                    {blockage ? (
                      <FormHelperText error style={{ whiteSpace: "pre-line" }}>
                        {!helpers[index] ? null : (
                          <>
                            {
                              "La création de BESCs est actuellement désactivée pour cet expéditeur"
                            }
                            <div style={{ whiteSpace: "pre-line" }}>
                              <Tooltip
                                arrow
                                title={
                                  <div>
                                    {helpers[0]?.nom
                                      ?.split("\n")
                                      .map((line, i) => (
                                        <div key={i}>{line}</div>
                                      ))}
                                  </div>
                                }
                              >
                                <span>
                                  <IconButton
                                    size="small"
                                    style={{ marginLeft: 4 }}
                                  >
                                    <InfoIcon fontSize="small" />
                                  </IconButton>
                                </span>
                              </Tooltip>
                            </div>
                          </>
                        )}
                      </FormHelperText>
                    ) : (
                      <FormHelperText error>
                        {!helpers[index] ? null : helpers[index].nom}
                      </FormHelperText>
                    )}
                  </FormControl>
                </Grid>

                <Grid item xs={8} sm={6} md={3}>
                  <FormControl
                    fullWidth
                    required={
                      createMode[0] &&
                      role &&
                      role.user &&
                      !role.user.company.consignataire
                    }
                    size="small"
                    className={classes.margin}
                    variant="outlined"
                  >
                    <InputLabel htmlFor="outlined-adornment-amount" shrink>
                      {formatMessage(
                        intl,
                        "create_besc_maritime_import_accordion_shippers_card_recipient_label_taxpayer_number",
                      )}
                    </InputLabel>
                    <OutlinedInput
                      id="outlined-adornment-amount"
                      color="secondary"
                      value={
                        role &&
                        role.user &&
                        role.user.company &&
                        role.user.company.account_local === "0" &&
                        ["Chargeur Principal", "Sous Compte Chargeur"].includes(
                          role.user.roles[0].name,
                        ) &&
                        !role.user.company.special_authorization &&
                        !role.user.company.consignataire &&
                        !role.user.company.forwarding_agent
                          ? fixedValue.niu
                          : value.niu
                      }
                      pattern=" ([^\s]*)"
                      name="niu"
                      dname="niu"
                      labelWidth={180}
                      error={!errors[index] ? false : errors[index].niu}
                      readOnly={
                        !createMode[index] ||
                        props.partnersData.length > 0 ||
                        (role &&
                          role.user &&
                          role.user.company &&
                          role.user.company.account_local === "0" &&
                          [
                            "Chargeur Principal",
                            "Sous Compte Chargeur",
                          ].includes(role.user.roles[0].name) &&
                          !role.user.company.special_authorization &&
                          !role.user.company.consignataire &&
                          !role.user.company.forwarding_agent)
                      }
                      onChange={(event) => handleChange(index, event)}
                      endAdornment={
                        niucheck[index] && (
                          <InputAdornment position="end">
                            <CircularProgress size={20} />
                          </InputAdornment>
                        )
                      }
                    />
                    <FormHelperText error>
                      {!helpers[index] ? null : helpers[index].niu}
                    </FormHelperText>
                  </FormControl>
                </Grid>

                <Grid item xs={8} sm={6} md={3}>
                  <FormControl
                    fullWidth
                    size="small"
                    required={createMode[0]}
                    className={classes.margin}
                    variant="outlined"
                  >
                    <InputLabel htmlFor="outlined-adornment-amount" shrink>
                      {formatMessage(
                        intl,
                        "create_besc_maritime_import_accordion_shippers_card_recipient_label_phone",
                      )}
                    </InputLabel>
                    <OutlinedInput
                      id="outlined-adornment-amount"
                      value={
                        role &&
                        role.user &&
                        role.user.company &&
                        role.user.company.account_local === "0" &&
                        ["Chargeur Principal", "Sous Compte Chargeur"].includes(
                          role.user.roles[0].name,
                        ) &&
                        !role.user.company.special_authorization &&
                        !role.user.company.consignataire &&
                        !role.user.company.forwarding_agent
                          ? fixedValue.tel
                          : value.tel
                      }
                      name="tel"
                      startAdornment={
                        <InputAdornment position="start">+237</InputAdornment>
                      }
                      labelWidth={180}
                      readOnly={
                        !createMode[index] ||
                        (role &&
                          role.user &&
                          role.user.company &&
                          role.user.company.account_local === "0" &&
                          [
                            "Chargeur Principal",
                            "Sous Compte Chargeur",
                          ].includes(role.user.roles[0].name) &&
                          !role.user.company.special_authorization &&
                          !role.user.company.consignataire &&
                          !role.user.company.forwarding_agent)
                      }
                      onKeyDown={(evt) => {
                        if (
                          isNaN(evt.key) &&
                          evt.key !== "." &&
                          evt.key !== "Backspace" &&
                          evt.key !== "ArrowLeft" &&
                          evt.key !== "ArrowRight" &&
                          evt.key !== "," &&
                          evt.key !== "v" &&
                          evt.key !== "V"
                        ) {
                          evt.preventDefault();
                        }
                      }}
                      onChange={(event) => handleChange(index, event)}
                      error={!errors[index] ? false : errors[index].tel}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={8} sm={6} md={3}>
                  <FormControl
                    fullWidth
                    required={createMode[0]}
                    size="small"
                    className={classes.margin}
                    variant="outlined"
                  >
                    <InputLabel htmlFor="outlined-adornment-amount" shrink>
                      {formatMessage(
                        intl,
                        "create_besc_maritime_import_accordion_shippers_card_recipient_label_email",
                      )}
                    </InputLabel>
                    <OutlinedInput
                      id="outlined-adornment-amount"
                      value={
                        role &&
                        role.user &&
                        role.user.company &&
                        role.user.company.account_local === "0" &&
                        ["Chargeur Principal", "Sous Compte Chargeur"].includes(
                          role.user.roles[0].name,
                        ) &&
                        !role.user.company.special_authorization &&
                        !role.user.company.consignataire &&
                        !role.user.company.forwarding_agent
                          ? fixedValue.email
                          : value.email
                      }
                      name="email"
                      labelWidth={180}
                      readOnly={
                        !createMode[index] ||
                        (role &&
                          role.user &&
                          role.user.company &&
                          role.user.company.account_local === "0" &&
                          [
                            "Chargeur Principal",
                            "Sous Compte Chargeur",
                          ].includes(role.user.roles[0].name) &&
                          !role.user.company.special_authorization &&
                          !role.user.company.consignataire &&
                          !role.user.company.forwarding_agent)
                      }
                      onChange={(event) => handleChange(index, event)}
                      error={!errors[index] ? false : errors[index].email}
                    />
                    <FormHelperText error>
                      {!helpers[index] ? null : helpers[index].email}
                    </FormHelperText>
                  </FormControl>
                </Grid>
                <Grid item xs={8} sm={6} md={3}>
                  <FormControl
                    fullWidth
                    size="small"
                    className={classes.margin}
                    variant="outlined"
                  >
                    <InputLabel htmlFor="outlined-adornment-amount" shrink>
                      {formatMessage(
                        intl,
                        "create_besc_maritime_import_accordion_shippers_card_recipient_label_address",
                      )}
                    </InputLabel>
                    <OutlinedInput
                      id="outlined-adornment-amount"
                      value={
                        role &&
                        role.user &&
                        role.user.company &&
                        role.user.company.account_local === "0" &&
                        ["Chargeur Principal", "Sous Compte Chargeur"].includes(
                          role.user.roles[0].name,
                        ) &&
                        !role.user.company.special_authorization &&
                        !role.user.company.consignataire &&
                        !role.user.company.forwarding_agent
                          ? fixedValue.adresse
                          : value.adresse
                      }
                      name="adresse"
                      labelWidth={180}
                      readOnly={!createMode[index]}
                      onChange={(event) => handleChange(index, event)}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={8} sm={6} md={3}>
                  <FormControl
                    fullWidth
                    size="small"
                    className={classes.margin}
                    variant="outlined"
                  >
                    <Autocomplete
                      open={openT[index]}
                      onOpen={() => {
                        let o = [...openT];

                        o[index] = true;
                        setOpenT(o);
                      }}
                      onClose={() => {
                        let o = [...openT];
                        o[index] = false;
                        setOpenT(o);
                        setVilles([]);
                      }}
                      loading={loadingT}
                      loadingText={formatMessage(
                        intl,
                        "create_besc_maritime_import_accordion_shippers_card_recipient_label_searching",
                      )}
                      value={
                        role &&
                        role.user &&
                        role.user.company &&
                        role.user.company.account_local === "0" &&
                        ["Chargeur Principal", "Sous Compte Chargeur"].includes(
                          role.user.roles[0].name,
                        ) &&
                        !role.user.company.special_authorization &&
                        !role.user.company.consignataire &&
                        !role.user.company.forwarding_agent
                          ? fixedValue.ville
                          : value.ville
                      }
                      readOnly={!createMode[index]}
                      hidden={!createMode[index]}
                      size="small"
                      onChange={(event, newValue) =>
                        handleAutoCompleteChangeV(index, event, newValue)
                      }
                      filterOptions={(options, params) => {
                        if (!loadingT) {
                          const filtered = filter(options, params);

                          return filtered;
                        } else {
                          return [];
                        }
                      }}
                      id="free-solo-with-text-demo "
                      options={villesR}
                      getOptionLabel={(option) => {
                        // Value selected with enter, right from the input
                        if (typeof option === "string") {
                          return option;
                        }
                        // Add "xxx" option created dynamically
                        if (option.inputValue) {
                          return option.text;
                        }
                        // Regular option

                        return option.ville + ", " + option.pays;
                      }}
                      renderInput={(params) => (
                        <TextField
                          fullWidth
                          {...params}
                          label={formatMessage(
                            intl,
                            "create_besc_maritime_import_accordion_shippers_card_recipient_label_town",
                          )}
                          variant="outlined"
                          required={createMode[0]}
                          onChange={(event) => {
                            event.persist(event);
                          }}
                        />
                      )}
                    ></Autocomplete>
                  </FormControl>
                </Grid>
              </Grid>
            </div>
          );
        })}
      </form>
    </Card>
  );
}
